import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DesktopMacIcon(props: IconProps) {
    return <Icon {...props} iconKey={"desktop_mac"}/>
}
